export default __webpack_public_path__ + "static/media/misc-books4-1920w.e376f5b0.avif";